import React, { lazy } from "react";
import { createRoutesFromElements, Route, Routes } from "react-router-dom";
import constants from "./constants";
const { ZEUSBOX_BASE_PATH } = constants

const HomeView = lazy(() => import("../views/Home/Home"))

export const routesConfig = (prefixPath: string) => {
    const fullPath = `${prefixPath}${ZEUSBOX_BASE_PATH}`;    
    const cleanPath = fullPath.endsWith('/') ? fullPath.slice(0, -1) : fullPath;

  return {
    prefixPath,
    elements: (
      <>
        <Route
          path={fullPath}
          element={<HomeView />}
        />
        <Route
          path={cleanPath}
          element={<HomeView />}
        />
        <Route path="*" element={<>Pagina no encontrada</>} />
      </>
    ),
  };
};

export const devRoutes = createRoutesFromElements(
  routesConfig("/admin/zeusbox-rgekt").elements
);

const AppRoutes = () => {
  return <Routes>{routesConfig("/admin/zeusbox-rgekt").elements}</Routes>;
};

export default AppRoutes;
